import { apiClient } from "../config";

async function getUserProfile(id: any) {
  const queryString = id ? `?person_id=${id}` : "";
  const res = await apiClient.get(`/admin/users/profile${queryString}`);
  return res.data;
}

export default getUserProfile;
